import { Box, Stack, Typography } from "@mui/material";
import { FormRegisters } from "./components/formRegister/FormRegister";

export function HomePage() {
  return (
    <Box width={["100%", "100%", "70%", "70%"]} mt={3}>
      <Stack direction={["column", "column", "row"]} width="100%" gap={2}>
        <Stack flex="1" p={2} gap={2}>
          <Typography>Paz do Senhor Jesus a todos irmãos!
          ,</Typography>
          <Typography>
          Congratulo - me prazerosamente pelo nobre acontecimento em nosso setor.
           Somos mui gratos a Deus por Ele nos conceder a realização
           da 3° edição da <strong>EBJ (escola Biblica de jovens)</strong>. 
          Que os nossos jovens sejam edificados, moldados e transformados pela palavra de Deus.
          </Typography>
          <Typography>
          Também quero externar a minha gratidão ao
          nosso Pastor setorial Maurício Costa, pelo apoio
          que nos tem oferecido. 
          </Typography>
          <Typography>
          Nesta oportunidade quero
          agradecer ao nosso coordenador Geral Pr. Antoniel Afonso e a comissão organizadora que tem trabalhado
         nos bastidores incansavelmente, afim de que essa edição seja bem sucedida e a todos os lideres de jovens locais bem como toda
         juventude.
      </Typography>
      <Typography>
         Que tudo transcorra num clima de adoração e
      submissão ao trino e soberano Deus, para que
      se manifeste com copiosas bênçãos e poder.

          </Typography>
          <Typography>
          Coop. Davidson.L Barboza  da Costa - Lider Setorial Cojadi - Itapevi.
          </Typography>
        </Stack>
        <FormRegisters />
      </Stack>
    </Box>
  );
}
